import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import logo from '../../assets/starcraneLogo.png';
import {
  FaArrowRight,
} from 'react-icons/fa';
import './HomePage.scss';
import AdminHomeDashboard from './AdminHomeDashboard';
import { isAdminRole } from './adminHomeData';

const tr = {
  operationCenter: 'OPERASYON MERKEZ\u0130',
  heroTitle: 'Kule Vincin Parlayan Y\u0131ld\u0131z\u0131',
  heroText:
    'Kule vin\u00e7 sat\u0131\u015f, kiralama ve teknik servis operasyonlar\u0131n\u0131 tek ekrandan takip edin.',
  primaryAction: 'Kule vin\u00e7leri g\u00f6r',
  secondaryAction: 'Vin\u00e7 ekle',
  fleet: '150+',
  fleetLabel: 'Kule Vin\u00e7',
  city: '81',
  cityLabel: '\u0130l Hizmeti',
  support: '7/24',
  supportLabel: 'Teknik Destek',
  overviewTitle: 'Operasyon Ak\u0131\u015f\u0131',
  overviewText: 'Kiralama, teknik servis ve saha takibi ayn\u0131 sistemde birle\u015fir.',
  liveSystem: 'Canl\u0131 Operasyon Paneli',
};

const getRoleFromToken = () => {
  const token = localStorage.getItem('token');
  if (!token) return '';

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || '';
  } catch {
    return '';
  }
};

const roleTargets = {
  Owner: '/grouptracking',
  Employee: '/grouptracking',
  RentalPersonnel: '/grouptracking',
  TechnicalServiceManager: '/technical-service',
  TechnicalServicePersonnel: '/technical-service/my-jobs',
  TechnicalServiceAccountant: '/technical-service/archive',
  Accountant: '/accounting',
  RentalAccountant: '/accounting',
  Partner: '/partner',
  Company: '/grouptracking',
};

const operationHighlights = [
  {
    title: 'Filo Takibi',
    text: 'Depo, \u015fantiye, kiralama ve teknik servis durumlar\u0131 tek operasyon haritas\u0131nda izlenir.',
  },
  {
    title: 'Kiralama S\u00fcreci',
    text: 'Mevcut saha bilgileri, kira tarihleri ve manuel ge\u00e7i\u015f kay\u0131tlar\u0131 kontroll\u00fc tutulur.',
  },
  {
    title: 'Teknik Servis',
    text: 'Ar\u0131za, bak\u0131m, ekip atamas\u0131 ve servis ar\u015fivi ayr\u0131 ama ba\u011fl\u0131 bir ak\u0131\u015fta y\u00f6netilir.',
  },
];

export default function HomePage() {
  return isAdminRole(getRoleFromToken()) ? <AdminHomeDashboard /> : <LegacyHomePage />;
}

function LegacyHomePage() {
  const navigate = useNavigate();
  const role = getRoleFromToken();

  const heroTarget = useMemo(() => roleTargets[role] || '/grouptracking', [role]);
  const addCraneAvailable = role === 'Owner' || role === 'Employee' || role === 'RentalPersonnel';

  useEffect(() => {
    if (role === 'TechnicalServicePersonnel') {
      navigate('/technical-service/my-jobs', { replace: true });
    }
  }, [navigate, role]);

  return (
    <div className="home-page">
      <Navbar />
      <main className="home-page__main">
        <section className="home-hero">
          <div className="home-hero__content">
            <img src={logo} alt="Star Crane" className="home-hero__logo" />
            <span className="home-hero__eyebrow">{tr.operationCenter}</span>
            <h1>{tr.heroTitle}</h1>
            <p>{tr.heroText}</p>
            <div className="home-hero__actions">
              <button type="button" onClick={() => navigate(heroTarget)}>
                {tr.primaryAction} <FaArrowRight />
              </button>
              {addCraneAvailable && (
                <button type="button" className="home-hero__secondary" onClick={() => navigate('/add-crane')}>
                  {tr.secondaryAction}
                </button>
              )}
            </div>
          </div>

          <div className="home-hero__stats">
            <div>
              <strong>{tr.fleet}</strong>
              <span>{tr.fleetLabel}</span>
            </div>
            <div>
              <strong>{tr.city}</strong>
              <span>{tr.cityLabel}</span>
            </div>
            <div>
              <strong>{tr.support}</strong>
              <span>{tr.supportLabel}</span>
            </div>
          </div>
        </section>

        <section className="home-overview">
          <div className="home-overview__header">
            <h2>{tr.overviewTitle}</h2>
            <p>{tr.overviewText}</p>
          </div>

          <div className="home-overview__grid">
            {operationHighlights.map((item, index) => (
              <article key={item.title} className="home-overview-card">
                <span>{String(index + 1).padStart(2, '0')}</span>
                <strong>{item.title}</strong>
                <p>{item.text}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="home-status-strip">
          <span>{tr.liveSystem}</span>
          <strong>Filo takibi</strong>
          <strong>{'Kiralama plan\u0131'}</strong>
          <strong>Teknik servis koordinasyonu</strong>
        </section>
      </main>
    </div>
  );
}
